import { render, staticRenderFns } from "./usercenter.vue?vue&type=template&id=1097fe94&scoped=true"
import script from "./usercenter.vue?vue&type=script&lang=js"
export * from "./usercenter.vue?vue&type=script&lang=js"
import style0 from "./usercenter.vue?vue&type=style&index=0&id=1097fe94&prod&lang=css"
import style1 from "./usercenter.vue?vue&type=style&index=1&id=1097fe94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097fe94",
  null
  
)

export default component.exports